import * as React from 'react';
import { useTranslation } from 'react-i18next';
import spadeIcon from './spade-icon.svg';
import './style.scss';

function Header() {
    const { t } = useTranslation('translations');

    return (
        <header className="header">
          <img className="header__logo" src={spadeIcon} alt={t('header.logoAlternateText')} />
          <div className="header__title">
              {t('header.title')}
          </div>
      </header>
    );
}

export default Header;
